import { Helmet } from "react-helmet-async";

const GlobalStructuredData = () => {
  const localBusiness = {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "FinancialService"],
    "@id": "https://processingbros.com",
    name: "Processing Bros",
    url: "https://www.processingbros.com",
    telephone: "+19543992230",
    email: "support@processingbros.com",
    image: "https://processingbros.com/processing-bros-icon-ios.png",
    logo: "https://processingbros.com/processing-bros-logo.png",
    description: "South Florida's trusted merchant services provider specializing in compliant cash discount programs. Eliminate 95% of credit card processing fees.",
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Fort Lauderdale",
      addressRegion: "FL",
      addressCountry: "US",
    },
    areaServed: [
      { "@type": "AdministrativeArea", name: "Broward County" },
      { "@type": "AdministrativeArea", name: "Miami-Dade County" },
      { "@type": "AdministrativeArea", name: "Palm Beach County" },
      { "@type": "Country", name: "United States" },
    ],
    sameAs: [
      "https://www.instagram.com/processingbros/",
      "https://www.facebook.com/profile.php?id=61565136844981",
      "https://share.google/t8iGjsNpxFOWNAPPR"
    ],
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "09:00",
        closes: "18:00",
      },
    ],
    foundingDate: "2024",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      bestRating: "5",
      worstRating: "1",
      reviewCount: "500",
    },
  };

  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Processing Bros",
    "url": "https://www.processingbros.com",
    "logo": "https://www.processingbros.com/processing-bros-icon-ios.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1-954-399-2230",
      "contactType": "customer service",
      "areaServed": "US",
      "availableLanguage": "English"
    },
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "FL",
      "addressCountry": "US"
    },
    "sameAs": [
      "https://facebook.com/profile.php?id=61565136844981",
      "https://instagram.com/processingbros",
      "https://share.google/t8iGjsNpxFOWNAPPR"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(localBusiness)}</script>
      <script type="application/ld+json">{JSON.stringify(organization)}</script>
    </Helmet>
  );
};

export default GlobalStructuredData;
